import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { faqs } from "./components/FAQ";
import Navbar from "@/components/feature/Navbar";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "@/components/feature/Footer";
import FloatingButton from "@/components/feature/FloatingButton";
import Avis from "@/components/feature/Avis";
import Hero from "./components/Hero";
import Reassurances from "./components/Reassurances";
import Bloque from "./components/Bloque";
import PannesUrgence from "./components/PannesUrgence";
import Intervention from "./components/Intervention";
import PourquoiAgir from "./components/PourquoiAgir";
import ReparerPlutot from "./components/ReparerPlutot";
import FAQ from "./components/FAQ";
import Galerie from "./components/Galerie";
import CTAAppel from "./components/CTAAppel";
import Maillage from "./components/Maillage";
import Formulaire from "./components/Formulaire";

export default function DepannagePage() {
  return (
    <div className="font-sans">
      <SEOHead
        title="Dépannage Volet Roulant Bloqué Strasbourg | Dépan'Volets"
        description="Volet bloqué ou qui ne remonte plus à Strasbourg ? Dépannage 24h par nos techniciens, toutes marques, devis gratuit. 03 74 47 32 40."
        path="/depannage-urgence"
        type="service"
        serviceType="Dépannage urgent de volet roulant"
        faqs={faqs}
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Dépannage urgence" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Dépannage urgence" }]} />
      <main>
        <Hero />
        <DiagnosticVideo />
        <Reassurances />
        <Bloque />
        <PannesUrgence />
        <Intervention />
        <CTAAppel />
        <PourquoiAgir />
        <ReparerPlutot />
        <FAQ />
        <Galerie />
        <Maillage />
        <Formulaire />
        <CTAAppel />
        <Avis />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}